(function(){
  'use strict';

  // ===== FACE CACHE HELPERS =====
var FACE_CACHE_KEY = 'vnk_face_cached';

function saveFaceToCache(faceKey){
  try{
    sessionStorage.setItem(FACE_CACHE_KEY, faceKey);
  }catch(e){}
}

function getFaceFromCache(){
  try{
    return sessionStorage.getItem(FACE_CACHE_KEY);
  }catch(e){
    return null;
  }
}


  // face-suggestions.js
  // Listens for vnk:faceDetected and renders up to 5 suggestions into #vnk-list.
  // Prefers server-rendered HTML in window.VNK_PRODUCT_HTML_BY_FACE (injected by Liquid).
  // Falls back to client-side simplified cards if needed.

  // runtime toggles
  var DEBUG = !!(window.__VNK_DEBUG);
  var MAX_SUGGESTIONS = 5;
  var PLACEHOLDER_SELECTOR = '#vnk-list'; // matches your section markup

  var CANONICAL = ['oval','round','square','rectangle','diamond','heart'];

  var SYNONYM_MAP = {
    'oblong': 'rectangle',
    'long': 'rectangle',
    'rect': 'rectangle',
    'ovalish': 'oval',
    'ovals': 'oval',
    'roundish': 'round',
    'heartshape': 'heart'
  };

  function log(){ if(DEBUG) console.log.apply(console, arguments); }
  function warn(){ console.warn.apply(console, arguments); }

  function normalizeFace(raw){
    if(!raw) return null;
    var s = String(raw).trim().toLowerCase();
    s = s.replace(/[\._]/g, ' ');
    s = s.replace(/[^a-z0-9 ]+/g,'');
    s = s.replace(/\s+/g,' ');
    if(CANONICAL.indexOf(s) !== -1) return s;
    if(SYNONYM_MAP[s]) return SYNONYM_MAP[s];
    for(var i=0;i<CANONICAL.length;i++){
      if(s.indexOf(CANONICAL[i]) !== -1) return CANONICAL[i];
    }
    return null;
  }

  function pickTopN(products, n){
    if(!Array.isArray(products)) return [];
    return products.slice(0, n);
  }

  // Render function: prefer server-rendered HTML map; fallback to JS-built cards
  function renderProducts(products, faceKey){
    var container = document.querySelector(PLACEHOLDER_SELECTOR); // #vnk-list
    var resultsCard = document.querySelector('#vnk-results');
    var resultLabel = document.querySelector('#vnk-result');

    if(!container){
      warn('face-suggestion: placeholder not found — selector', PLACEHOLDER_SELECTOR);
      return;
    }

    container.innerHTML = '';

    if(resultsCard) resultsCard.hidden = false;
    if(resultLabel) resultLabel.textContent = 'Detected: ' + (faceKey ? String(faceKey).toUpperCase() : '');

    var htmlMap = (window.VNK_PRODUCT_HTML_BY_FACE && window.VNK_PRODUCT_HTML_BY_FACE[faceKey]) || null;
    var fullList = (window.VNK_PRODUCTS_BY_FACE && window.VNK_PRODUCTS_BY_FACE[faceKey]) || (products || []);
    var toShow = Math.min(MAX_SUGGESTIONS, fullList.length);

    // If server-provided HTML is available and non-empty, use it
    if(htmlMap && Array.isArray(htmlMap) && htmlMap.length > 0){
      // htmlMap was limited to <=5 by Liquid; but enforce bounds anyway
      for(var i=0;i<toShow && i<htmlMap.length;i++){
        var html = htmlMap[i];
        // insert as <li> if not already an li
        if(/^\s*<li/i.test(html)){
          container.insertAdjacentHTML('beforeend', html);
        } else {
          container.insertAdjacentHTML('beforeend', '<li class="vnk-suggestion-item">' + html + '</li>');
        }
      }
    } else {
      // fallback: build simple card markup
      for(var j=0;j<toShow && j<products.length;j++){
        var prod = products[j];
        var li = document.createElement('li');
        li.className = 'vnk-suggestion-item';
        li.innerHTML = '' +
          '<a class="vnk-suggestion-link" href="'+ (prod.url || prod.handle || '#') +'" data-product-id="'+ (prod.id || '') +'">' +
            '<img class="vnk-suggestion-image" src="'+ (prod.image || '') +'" alt="'+ (prod.title||'') +'" width="120" height="120" loading="lazy">' +
            '<div class="vnk-suggestion-meta"><div class="vnk-suggestion-title">'+ (prod.title||'') +'</div>' +
            (prod.price ? '<div class="vnk-suggestion-price">'+ prod.price +'</div>' : '') +
            '</div>' +
          '</a>';
        container.appendChild(li);
      }
    }

    // Add "View more" if full list is larger than MAX_SUGGESTIONS
    if(fullList.length > MAX_SUGGESTIONS){
      var collHandle = (window.VNK_COLLECTION_BY_FACE && window.VNK_COLLECTION_BY_FACE[faceKey]) || null;
      var viewMoreLi = document.createElement('li');
      viewMoreLi.className = 'vnk-suggestion-item vnk-view-more';
      var href = '/pages/face-type';
      if(collHandle){
        href = '/collections/' + collHandle;
      }
      viewMoreLi.innerHTML = '<a class="vnk-suggestion-link" href="'+ href +'">' +
        '<div class="vnk-view-more-card"><div class="vnk-view-more-inner">View more →</div></div></a>';
      container.appendChild(viewMoreLi);
    }

    // bring results into view
    if(resultsCard) resultsCard.scrollIntoView({behavior:'smooth', block:'center'});
  }

  function getProductsFor(faceKey){
    if(!faceKey) return [];
    var store = window.VNK_PRODUCTS_BY_FACE;
    if(!store){
      warn('face-suggestion: expected window.VNK_PRODUCTS_BY_FACE to be present.');
      return [];
    }
    var arr = store[faceKey] || [];
    if(!Array.isArray(arr)) arr = [];
    return arr;
  }

  function acceptFaceRaw(rawFace){
    log('face-suggestion: rawFace:', rawFace);
    var canonical = normalizeFace(rawFace);
    if(!canonical){
      warn('face-suggestion: could not normalize face type "' + rawFace + '"');
      window.VNK_FACE_SUGGESTIONS = window.VNK_FACE_SUGGESTIONS || {};
      window.VNK_FACE_SUGGESTIONS.lastSuggestions = [];
      window.VNK_FACE_SUGGESTIONS.lastFace = rawFace;
      renderProducts([], canonical);
      return;
    }

    var products = getProductsFor(canonical);
    var picked = pickTopN(products, MAX_SUGGESTIONS);

    window.VNK_FACE_SUGGESTIONS = window.VNK_FACE_SUGGESTIONS || {};
    window.VNK_FACE_SUGGESTIONS.lastSuggestions = picked;
    window.VNK_FACE_SUGGESTIONS.lastFace = canonical;
    renderProducts(picked, canonical);
  }

  function onCustomEvent(e){
    if(!e || !e.detail) return;
    log('face-suggestion: received vnk:faceDetected event');
    if(DEBUG) console.log('face-suggestion: event detail:', e.detail);
    var det = e.detail;
    var candidate = det.face_shape || det.faceType || det.faceTypeDetected || det.face;
    if(candidate) acceptFaceRaw(candidate);
    else console.warn('face-suggestion: event detail present but no face field found', det);
  }

  // Polling fallback to pick up detector-exposed global last detection
  function startPollingFallback(timeoutMs){
    timeoutMs = timeoutMs || 5000;
    var start = Date.now();
    var interval = setInterval(function(){
      var vf = window.VNK_FACE;
      if(vf && vf.lastDetected){
        clearInterval(interval);
        log('face-suggestion: picked up lastDetected via polling fallback');
        acceptFaceRaw(vf.lastDetected.face_shape || vf.lastDetected.face);
        return;
      }
      if(Date.now() - start > timeoutMs){
        clearInterval(interval);
        log('face-suggestion: polling fallback timed out');
      }
    }, 250);
  }

  function init(){
    try {
      window.addEventListener('vnk:faceDetected', onCustomEvent, false);
    } catch(err){
      warn('face-suggestion: failed to attach event listener', err);
    }

    if(window.VNK_FACE && window.VNK_FACE.lastDetected){
      var last = window.VNK_FACE.lastDetected;
      acceptFaceRaw(last.face_shape || last.face);
    } else {
      startPollingFallback(3000);
    }

    log('face-suggestion initialized. Listening for vnk:faceDetected events.');
  }

     // auto-trigger from persisted style profile
  try {
    var raw = localStorage.getItem('vnk_style_profile');
    if (raw) {
      var profile = JSON.parse(raw);
      if (profile && profile.face) {
        acceptFaceRaw(profile.face);
        
      }
    }
  } catch(e){}


  // Expose API
  window.VNK_FACE_SUGGESTIONS = window.VNK_FACE_SUGGESTIONS || {};
  window.VNK_FACE_SUGGESTIONS.triggerFor = function(rawFace){
    acceptFaceRaw(rawFace);
  };
  
  window.VNK_FACE_SUGGESTIONS.runForFace = function(faceKey){
  acceptFaceRaw(faceKey);
};

  window.VNK_FACE_SUGGESTIONS.setDebug = function(val){
    window.__VNK_DEBUG = !!val;
    DEBUG = !!val;
    console.log('VNK debug set to', DEBUG);
  };
  window.VNK_FACE_SUGGESTIONS.installWatcher = function(){
    if(window.__VNK_DEV_WATCHER) return console.log('watcher already installed');
    window.__VNK_DEV_WATCHER = true;
    window.addEventListener('vnk:faceDetected', function(e){
      console.log('%cVNK EVENT:', 'background:#222;color:#bada55', e.detail);
    });
    console.log('VNK watcher installed');
  };

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }


  
})();



